export default "https://skrwd-shindan.herokuapp.com/packs/media/images/LINE_Icon-fbeb5087e1260d6581a3a8b332b2e7d8.png";